<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>货位整合任务</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                ref="search_form"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item label="输入搜索：" prop="ds_id">
                  <el-input
                    v-model="form.ds_id"
                    placeholder="任务单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="create_admin">
                  <el-input
                    v-model="form.create_admin"
                    placeholder="创建人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="dbid">
                  <el-input
                    v-model="form.dbid"
                    placeholder="打标id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="status">
                  <el-select
                    v-if="resData"
                    v-model="form.status"
                    placeholder="状态"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in statusOption"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="down_shelf_type">
                  <el-select
                    v-if="resData"
                    v-model="form.down_shelf_type"
                    placeholder="类型"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in downShlefType"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="receive_admin">
                  <el-input
                    v-model="form.receive_admin"
                    placeholder="上架人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="创建时间：" prop="create_time">
                  <el-date-picker
                    v-model="form.create_time"
                    :default-time="['06:00:00', '06:00:00']"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="完成时间：" prop="complete_time">
                  <el-date-picker
                    v-model="form.complete_time"
                    :default-time="['06:00:00', '06:00:00']"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button type="primary" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="outputDetail"
          >
            整合明细导出</el-button
          >
          <el-button style="" type="success" size="mini" @click="output">
            导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
          >
            <el-table-column
              prop="ds_id"
              label="货位整合单号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="创建人"
              width="100"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="num"
              label="任务数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="sku_num"
              label="sku数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="down_shelf_type"
              label="类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="downshelf_status"
              label="任务状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="任务创建时间"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="sub_time"
              label="任务提交时间"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="receive_name"
              label="上架人"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="start_time"
              label="开始上架时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="complete_time"
              label="完成上架时间"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="exception_admin"
              label="异常处理人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="exception_time"
              label="异常处理时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              label="异常数据"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.exception_dbids">
                  <div
                    v-for="dbid in scope.row.exception_dbids.split(',')"
                    :key="dbid"
                  >
                    {{ dbid }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" prop="goods_name">
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click="showDbids(scope.row)">
                    查看明细</el-button
                  >
                </div>
                <div>
                  <el-button
                    v-if="scope.row.status == 1 || scope.row.status == 2"
                    type="text"
                    style="color: red"
                    @click="stop(scope.row)"
                    >结束任务</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="currentPage"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.total"
            :page-size="form.page_size"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        origin: 1,
        create_time: this.$excalibur.getDateTimeOnHours(-15, 6),
        page_size: 100,
        down_shelf_type: "",
      },
      loading: false,
      url: "/erp/DownShelf/index",
      origin: [
        { key: 1, label: "广州" },
        { key: 2, label: "杭州" },
      ],
      currentPage: 1,
      tableLoading: false,
      filterFold: false,
      statusOption: [],
      downShlefType: [],
      statics: {
        fahuo: 0,
        stock: 0,
      },
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    outputDetail() {
      this.$http
        .post("/erp/DownShelf/exportDetail", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.currentPage = 1;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.statusOption = res.data.data.statusOption;
          this.downShlefType = res.data.data.downShelfType;
          this.statics = res.data.data.statics;
        }
      });
    },
    showDbids(row) {
      const id = row.ds_id;
      this.$router.push(`/home/downshelf/detail/${id}`);
    },
    stop(row) {
      const id = row.ds_id;
      this.$confirm("是否确认结束任务", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/DownShelf/stopDownshelf", { ds_id: id })
            .then((res) => {
              setTimeout(() => {
                this.loading = false;
              }, 200);
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.$message.success("结束任务成功");
                this.fetchData();
              }
            });
        })
        .catch(() => {});
    },
    // 重置
    reset() {
      this.$refs.search_form.resetFields();
    },
  },
};
</script>

<style scoped>
.filter {
  border: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// src/pages/downshelf/index.vue